// „Всички / Без обедно / Само обедно" — стойностите на LunchScopeToggle.
export type LunchScope = "all" | "regular" | "lunch";

// „По категории" → „Асортименти": кликнат обеден/обикновен ред носи обхвата си
// в URL-а (?lunch=lunch|regular), за да не се отвори смесено с другите продажби.
export const LUNCH_SCOPE_PARAM = "lunch";

export const lunchScopeFromParam = (value: string | null): LunchScope =>
  value === "lunch" || value === "regular" ? value : "all";

/**
 * Обхватът на кликнат ред от „По категории": обеденият → само обедни, обикновеният
 * → без обедни (когато в периода има обедни продажби), иначе без стеснение.
 */
export const setLunchScopeParam = (search: URLSearchParams, isLunchRow: boolean, hasLunch: boolean) => {
  if (isLunchRow) search.set(LUNCH_SCOPE_PARAM, "lunch");
  else if (hasLunch) search.set(LUNCH_SCOPE_PARAM, "regular");
  else search.delete(LUNCH_SCOPE_PARAM);
  return search;
};

/** Видовете към BE според превключвателя и филтъра в колоната „Тип". */
export const kindsForLunchScope = <Kind extends string>(
  scope: LunchScope,
  columnKinds: Kind[],
  allKinds: Kind[],
  lunchKind: Kind,
): Kind[] => {
  if (scope === "lunch") return [lunchKind];
  if (scope === "regular") {
    const base = columnKinds.length ? columnKinds : allKinds;
    const regular = base.filter((kind) => kind !== lunchKind);
    // Колоната е оставила само „Обедно" — празен списък BE-то чете като
    // „всички", затова падаме до всички без обедното.
    return regular.length ? regular : allKinds.filter((kind) => kind !== lunchKind);
  }
  return columnKinds;
};
